module.exports = __webpack_public_path__ + "media/images/covid/cs/close-contact_settings-6c666ce61df38e14ea335575947c8dbc.png";